export const GET_PREVIOUS_FILTERS = 'GET_PREVIOUS_FILTERS';
export const SET_PREVIOUS_FILTERS = 'SET_PREVIOUS_FILTERS';

export const PREVIOUS_FILTERS = 'PREVIOUS_FILTERS';
